<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="categories"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Runtime Categories Config</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item.show="{ item }">
          <v-tooltip v-if="item.show" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="updateCategory({ ...item, show: false })"
              >
                <v-icon>
                  {{ mdiEye }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category shown</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="updateCategory({ ...item, show: true })"
              >
                <v-icon>
                  {{ mdiEyeOff }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category hidden</span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            {{ mdiPencil }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialog" max-width="700px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Update category</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="editedItem.title"
                  label="Title"
                  filled
                  v-validate="{
                    required: true
                  }"
                  name="title"
                  :error-messages="errors.collect('tile')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mdiPencil, mdiEye, mdiEyeOff } from "@mdi/js"
export default {
  data () {
    return {
      mdiPencil,
      mdiEye,
      mdiEyeOff,
      dialog: false,
      categories: [],
      editedItem: { title: null },
      headers: [
        {
          text: 'Title',
          value: 'title',
          sortable: false,
        },
        {
          text: 'Category key',
          value: 'category',
          sortable: false
        },
        {
          text: 'Show',
          value: 'show',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ]
    }
  },
  async created() {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/runtime-categories')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.categories = data;
    }
  },
  methods: {
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = { title: null }
      }, 300)
    },
    editItem (item) {
      this.editedItem = { ...item }
      this.dialog = true
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          await this.updateCategory(this.editedItem)
        }
      })
    },
    async updateCategory (item) {
      const { data } = await this.$axios.put(this.$store.getters.projectPath + '/runtime-categories/' + item.id, item)
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.categories.findIndex(category => category.id === data.id)
        this.$set(this.categories, index, data)
        this.close()
      }
    }
  }
}
</script>